// extracted by mini-css-extract-plugin
export var closeButton = "_jf-1";
export var closeX = "_jf-3";
export var container = "_jf-0";
export var image = "_jf-2";